import { Expandable } from "./expandable";
import type { ExpansionStrategy } from "./expandable-controller";

export class ContainerExpansionStrategy implements ExpansionStrategy {
    collapse(content: Expandable): void {
        content.expanded = false;
    }

    expand(content: Expandable): void {
        content.expanded = true;
    }

    getLoadingElement(content: Expandable): HTMLElement {
        const contentContainer = content.content;
        if (!contentContainer) {
            throw new Error("Container strategy requires content container");
        }

        return contentContainer;
    }

    applyLoadedContent(content: Expandable, html: string): void {
        const contentContainer = content.content;
        if (!contentContainer) {
            throw new Error("Container strategy requires content container");
        }

        contentContainer.innerHTML = html;
    }
}
